import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import  Asasname  from "Assets/Images/asasname.png"
import { useNavigate } from 'react-router-dom';
import DownloadLinkDirectly from 'Components/DownloadLinkDirectly'

const IrenexStatute = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const navigate = useNavigate();
    useEffect(() => {
        if (currentLang !== 'fa') {
            navigate('/');;
        }
    }, [currentLang, navigate]);
    const content = {
        fa: {
            description: (
                <>
                    در این قسمت می‌توانید <strong className="fw-bold">اساسنامه شرکت بورس انرژی ایران</strong> که شامل موارد زیر است را دانلود کنید:
                </>
            ),
            list: [
                "تعاریف",
                "نام - موضوع - مدت - تابعیت و مرکز اصلی",
                "چارچوب فعالیت",
                "سرمایه، ترکیب سهام‌داران و نقل و انتقال سهام",
                "ارکان شرکت",
                "مجامع عمومی",
                "هیئت‌مدیره",
                "مدیرعامل",
                "بازرس / حسابرس",
                "سایر موارد"
            ],
        },
        en: {
            description: (
                <>
                    Here you can download the <strong className="fw-bold">Articles of Association of the Iran Energy Exchange</strong>, which includes the following sections:
                </>
            ),
            list: [
                "Definitions",
                "Name – Purpose – Duration – Nationality and Headquarters",
                "Scope of Activity",
                "Capital, Shareholders Composition, and Share Transfer",
                "Company Organs",
                "General Assemblies",
                "Board of Directors",
                "Managing Director",
                "Auditor / Inspector",
                "Other Provisions"
            ],
        },
        ar: {
            description: (
                <>
                    يمكنك هنا تنزيل <strong className="fw-bold">النظام الأساسي لشركة بورصة الطاقة الإيرانية</strong>، والذي يشمل الأقسام التالية:
                </>
            ),
            list: [
                "التعاريف",
                "الاسم – الموضوع – المدة – الجنسية والمقر الرئيسي",
                "إطار النشاط",
                "رأس المال، تكوين المساهمين، وتحويل الأسهم",
                "هيئات الشركة",
                "الجمعيات العامة",
                "مجلس الإدارة",
                "المدير التنفيذي",
                "المدقق / المفتش",
                "مواد أخرى"
            ],
        },
    };

    const { description, list } = content[currentLang] || content.fa; // fallback to fa
    return (
        <div className="megaMenuContent">
            <div className="row">
                <div className="col-4">
                    <img
                        src={Asasname}
                        className="mx-auto max-width-100 width-100"
                        alt={t('statute') }
                    />
                </div>
                <div className="col-6">
                    <p className="text-nowrap">{description}</p>
                    <ul className="IeeStatuteList">
                        {list.map((item, idx) => (
                            <li key={idx}>{item}</li>
                        ))}
                    </ul>
                    
                </div>
                <div className="col-12 align-self-end justify-content-end d-flex justify-content-end">
                    <DownloadLinkDirectly classList="btn btn-download cursor-pointer" fileUrl="AboutUs/GetStatutes" linkText={t('download_statute')} />
                </div>
            </div>
            
        </div>
    );
};

export default IrenexStatute;
